import styled from "styled-components"
import { colors } from "./base"

export const LayoutContainer = styled.div`
  display: flex;
  @import url('https://fonts.googleapis.com/css?family=Nunito|Pacifico|Sanchez&display=swap');
  //@import url("https://fonts.googleapis.com/css?family=Pacifico|Sanchez&display=swap);
  //font-family: Nunito Sans,sans-serif;

  @media only screen and (max-width: 950px) {
    //transition: all 2s;

    display: flex;
    flex-direction: column;
  }
  a {
    box-shadow: 0 0px 0 0 inherit;
  }

  // code {
  //   background: ${colors.mainSecondaryBackground};
  //   padding: 3px;
  //   border-radius: 4px;
  // }

  pre {
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    border: ${colors.headerTextShadow} 2px solid;
    background: ${colors.sideNavBackground};
  }

  code {
    font-family: monospace;
    font-size: 16px;
  }
`
